export default {
  ratePlanType: {
    STANDARD: 'Standard',
    BAR: 'Meilleur tarif disponible',
    CORPORATE: 'Entreprise',
    MEMBER: 'Membre',
    PACKAGE: 'Forfait',
    PROMOTIONAL: 'Promotion',
    OTA: 'OTA',
    WHOLESALE: 'Grossiste',
    NEGOTIATED: 'Négocié',
    MIXED: 'Tarif combiné',
  },
} as const;
